import api from './Axios';

export const wipeTestData = async () => {
  try {
    const response = await api.post('/api/accounts/wipe-test-data/', {
      confirm: 'yes'
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};